import PropTypes from 'prop-types'

import { Caption1 } from '@thebeansgroup/sb_ui/typography'
import Colours from '@thebeansgroup/ui_style_helpers/colours'

import * as styles from './styles'

const InputSubLabel = ({ subLabel }) => (
  <div css={styles.container}>
    <Caption1 colour={Colours('grey', '350')}>{subLabel}</Caption1>
  </div>
)

InputSubLabel.propTypes = {
  subLabel: PropTypes.string.isRequired
}

export default InputSubLabel
